import React from "react";
import * as styles from "./Mobile.module.scss";
import { mobileShared } from "@shared/arrays/dashly-vs";

export function Mobile() {
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <div className={styles.content}>
          <h2 className={styles.heading}>{mobileShared.title}</h2>
          <p className={styles.lead}>{mobileShared.lead}</p>
          <p className={styles.text}>{mobileShared.text}</p>

          <div className={styles.badges}>
            {mobileShared.badges.map((b) => (
              <img key={b.src} src={b.src} alt={b.alt} loading="lazy" decoding="async" />
            ))}
          </div>
        </div>

        <div className={styles.media}>
          {mobileShared.images.map((img) => (
            <img
              key={img.src}
              src={img.src}
              alt={img.alt}
              loading="lazy"
              decoding="async"
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Mobile;
